import React from 'react';
import { Box, IconButton, styled } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

const SocialBarContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5),
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  boxShadow: '0 3px 15px rgba(0,0,0,0.2)',
  borderRadius: '12px 0 0 12px',
  '&:hover': {
    backgroundColor: '#ffffff',
  },
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const SocialIconButton = styled(IconButton)({
  width: 40,
  height: 40,
  padding: 0,
  minWidth: 40,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease-in-out',
  '& .MuiSvgIcon-root': {
    width: 24,
    height: 24,
    transition: 'all 0.3s ease-in-out',
  },
  '&:hover': {
    transform: 'rotate(360deg) scale(1.15)',
  },
});

const socialLinks = [
  {
    icon: <FacebookIcon />,
    color: '#1877F2',
    hoverColor: '#0d6efd',
    url: 'https://www.facebook.com/aaradhyarealty'
  },
  {
    icon: <WhatsAppIcon />,
    color: '#25D366',
    hoverColor: '#20bd5a',
    url: 'https://wa.me/919766628387'
  },
  {
    icon: <InstagramIcon />,
    color: '#E4405F',
    hoverColor: '#d62e4c',
    url: 'https://www.instagram.com/aaradhya_finance_and_realty'
  },
  {
    icon: <YouTubeIcon />,
    color: '#FF0000',
    hoverColor: '#e60000',
    url: 'https://www.youtube.com/@AaradhyaFinanceAndRealty'
  }
];

function SocialMediaBar() {
  return (
    <SocialBarContainer>
      {socialLinks.map((social, index) => (
        <SocialIconButton
          key={index}
          component="a"
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            bgcolor: social.color,
            '& .MuiSvgIcon-root': {
              color: '#ffffff',
            },
            '&:hover': {
              bgcolor: social.hoverColor,
              '& .MuiSvgIcon-root': {
                color: '#ffffff',
              },
            },
          }}
        >
          {social.icon}
        </SocialIconButton>
      ))}
    </SocialBarContainer>
  );
}

export default SocialMediaBar; 